/**
 * PT-Anzeige der Ist-Besetzung (PV-032), rein und testbar.
 *
 * Salesforce pflegt „Beauftragte PT" / „Verbleibende PT" an der Projektbesetzung
 * nur bei EXTERNEN Beauftragungen. Bei internen Mitarbeitenden stehen dort 0/0 —
 * das heisst „nicht anwendbar", nicht „null Tage". Zwei Nullen als Zahlen
 * anzuzeigen liest sich wie „Kontingent aufgebraucht" und ist damit irrefuehrend.
 *
 * Regel: NUR wenn beide Werte fehlen oder beide 0 sind, wird nichts angezeigt.
 * Eine einzelne 0 bei den verbleibenden PT bleibt stehen — ein aufgebrauchtes
 * Kontingent ist eine echte Aussage, die diese Regel nicht verschlucken darf.
 */
function fmt(value: number | null): string {
  return value === null ? '—' : value.toLocaleString('de-DE');
}

export function formatPtPaar(
  beauftragt: number | null,
  verbleibend: number | null,
): { beauftragt: string; verbleibend: string } {
  const nichtGepflegt =
    (beauftragt === null || beauftragt === 0) && (verbleibend === null || verbleibend === 0);
  if (nichtGepflegt) {
    return { beauftragt: '—', verbleibend: '—' };
  }
  return { beauftragt: fmt(beauftragt), verbleibend: fmt(verbleibend) };
}

/** PV-052 L3: gebuchte Stunden, höchstens eine Nachkommastelle. Fehlend = noch kein Ist → „—". */
export function formatStunden(stunden: number | null | undefined): string {
  if (stunden === null || stunden === undefined) return '—';
  return stunden.toLocaleString('de-DE', { maximumFractionDigits: 1 });
}

/** PV-052 L3: `YYYY-MM-DD` → `TT.MM.JJJJ`; fehlend → „—". */
export function formatDatumKurz(iso: string | null | undefined): string {
  if (!iso) return '—';
  const [j, m, t] = iso.split('-');
  return `${t}.${m}.${j}`;
}
